import React, { useState, useContext, useEffect } from "react";
import HeaderTabs from "../../../components/Header2Tabs";
import { AppContext } from "../../../ContextApi";
import ClaimFeaturesTabs from "../components/ClaimFeaturesTabs";
import Claimstatus from "../../Claimstatus";
import Intimate_my_claims from "../../Intimate_my_claims";

const ClaimCorner = () => {
  const { featuresType, intimateArray, claimSubmissionVisiblity, tabapiData } =
    useContext(AppContext);
  const [activeViewType, setActiveViewType] = useState(0); // 0 for Claim Status and 1 for Intimate

  return (
    <>
      <div className="main-escalation-cover-wrapper claim-app-home-main-cover-wrapper">
        <HeaderTabs />
        <div className="separater-box"></div>
        <div className="claim-corner-main-cover-wrapper">
          <ClaimFeaturesTabs
            tabapiData={tabapiData}
            setActiveViewType={setActiveViewType}
            featuresType={featuresType}
            activeViewType={activeViewType}
          />
          {activeViewType == 0 ? <Claimstatus activeViewType={activeViewType} setActiveViewType={setActiveViewType}  /> : <Intimate_my_claims />}
        </div>
      </div>
    </>
  );
};

export default ClaimCorner;
